import React from 'react'
import "./css/navbar.css"
import Logo from "../images/new-logo.png"

import NavCircleBg from "../images/navbar-circle-toggle.png"

class Submenu extends React.Component {
  render() {
    return (
      <ul 
        className={`scaffold nav__submenu ${this.props.theClass}`}
      >
        
        <img id='nav-circle-bg' src={NavCircleBg} alt="circle-bg"></img>
        <li id="nl-1" className="nav__submenu-item ">
          <a className="nav__submenu-item-link" href="/">About</a>
        </li>
        <li id="nl-2" className="nav__submenu-item ">
          <a className="nav__submenu-item-link" href="/">Support</a>
        </li>
        <li id="nl-3" className="nav__submenu-item ">
          <a className="nav__submenu-item-link" href="./Login">Login</a>
        </li>
      </ul>
    )
  }
}


class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showingDropDownMenu: false,
      menuClass: "",
      submenuClass: "right-side-out"
    };
  }

  handleClick = () => {
    if (this.state.showingDropDownMenu) { // hide menu
      this.setState({
        ...this.state,
        showingDropDownMenu: false, 
        menuClass: "",
        submenuClass: "right-side-out"
      })
    } else { // show menu
      this.setState({
        ...this.state,
        showingDropDownMenu: true, 
        menuClass: "openMenu",
        submenuClass: "right-side-in"
      })
    }
  }

  handleLeave = () => {
    this.setState({
      ...this.state,
      showingDropDownMenu: false, 
      menuClass: "",
      submenuClass: "right-side-out"
    })
  }

  render() {
    return (
      <div className='display-flex' id='navbar' >

        {/* nav logo container */}
        <div id='nav-logo-container'>
          <div id="logo-bg-circle">
            <img id='nav-logo' src={Logo} alt="CarePlus"></img>
          </div>
        </div>

        {/* about, support and login links */}
        <div className='display-flex' id='nav-links-container'>
            <a className='nav-links' href="/">About</a>
            <a className='nav-links' href="/">Support</a>
            {/* <div id="nav-login-behind"></div> */}
            <button 
              className='button-shake' 
              id='nav-login' 
              onClick={() => document.location="./Login"}
            >
              LOGIN
            </button>
        </div>

        {/* hamburger link */}
        <div className='display-flex' id='hamburger-container'>
          
          <button id="ham-button" onMouseLeave={this.handleLeave}>
            <div 
              id="menu-container" 
              className={this.state.menuClass}
              onClick={this.handleClick}
            >
              <div className="menu-line" id='menu-line-1'></div>
              <div className="menu-line" id='menu-line-2'></div>
              <div className="menu-line" id='menu-line-3'></div>
            </div>

            <Submenu theClass = {this.state.submenuClass} />
          </button>
        </div>
      </div>
    )
  }
}

export default NavBar;